import ApiClient from 'dashboard/api/ApiClient';

// The account's forms: get() lists them, update(id, { form }) edits one's texts and status.
class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }
}

export default new FormsAPI();
